import { RenderRichTextData, ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'
import { SxProps } from '@mui/system'
import * as RichTextRenderer from '@contentful/rich-text-react-renderer'
import * as RichTextTypes from '@contentful/rich-text-types'

export type RenderMark = RichTextRenderer.RenderMark
export type RenderNode = RichTextRenderer.RenderNode
export type CommonNode = RichTextRenderer.RenderNode
export type NodeRenderer = RichTextRenderer.NodeRenderer
export type RenderText = RichTextRenderer.RenderText
export const BLOCKS = RichTextTypes.BLOCKS
export const INLINES = RichTextTypes.INLINES
export const MARKS = RichTextTypes.MARKS

export type ComponentMap<T extends string> = Record<T, (props: unknown) => React.ReactNode>
export interface IRichText extends RenderRichTextData<ContentfulRichTextGatsbyReference> {
  parentModule?: string
  renderMark?: Partial<RenderMark>
  renderNode?: Partial<RenderNode>
  renderText?: RenderText
  sx?: SxProps
  linkIcon?: boolean
  componentMap?: ContentfulToComponent
  propsMap?: ContentfulToComponentProps
}

export type ContentfulType =
  | 'ContentfulModuleBox'
  | 'ContentfulComponentCta'
  | 'ContentfulModuleCallUsGraph'
  | 'ContentfulLayoutCarousel'
  | 'ContentfulPageCompose'
  | 'HelpUniverseLayoutCarousel'
  | 'ContentfulComponentContentModule'
  | 'ContentfulComponentDialog'
  | 'ContentfulComponentFaq'
  | 'ContentfulModuleForm'
  | 'ContentfulComponentIconBullet'
  | 'ContentfulModuleLinevisitation'
  | 'ContentfulComponentLink'
  | 'ContentfulComponentList'
  | 'ContentfulComponentIcon'
  | 'ContentfulModulePriceComparison'
  | 'ContentfulSpeedtest'
  | 'ContentfulSpeedtestVisual'
  | 'HelpUniverseLayoutColumns'
  | 'HelpUniverseComponentText'
  | 'HelpUniverseComponentCard'
  | 'HelpUniversePageSubcategory'
  | 'HelpUniverseComponentAccordion'
  | 'HelpUniverseComponentImage'
  | 'HelpUniverseComponentList'
  | 'HelpUniverseComponentAlert'
  | 'HelpUniverseModuleDynamicComponents'
  | 'ContentfulComponentAlert'
  | 'HelpUniverseModuleForm'
  | 'HelpUniverseComponentCta'
  | 'HelpUniverseComponentTabs'
  | 'HelpUniverseComponentIcon'
  | 'HelpUniverseComponentTimeline'
  | 'HelpUniverseComponentChip'
  | 'ContentfulModuleDynamicComponents'
  | 'ContentfulComponentFeedback'
  | 'HelpUniverseComponentFeedback'

type PropCastFunction = <T>(props: any) => T

export type ContentfulToComponent = Record<ContentfulType, (props: any) => React.ReactNode>

export type ContentfulToComponentProps = Record<ContentfulType, PropCastFunction>
